/* unplugin-vue-components disabled */import { render } from "./popupNew.vue?vue&type=template&id=8598fe9c&scoped=true"
import script from "./popupNew.vue?vue&type=script&lang=js"
export * from "./popupNew.vue?vue&type=script&lang=js"

import "./popupNew.vue?vue&type=style&index=0&id=8598fe9c&lang=less&scoped=true"

import exportComponent from "D:\\dianzhong\\cps-expert-popularize\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8598fe9c"]])

export default __exports__